export const translations = {
  nl: {
    nav: {
      emtay: "Emtay",
      services: "Diensten",
      contact: "Contact",
      ourmethod: "Werkwijze",
      ourservices: "Onze diensten",
    },
    hero: {
      title: "Emtay: agentic engineering",
      subtitle: "Wij helpen organisaties software uitdagingen om te zetten naar resultaten.",
    },
    counters: {
      yearsExperience: "23 jaar ervaring",
      yearsDescription:
        "Decennia softwareontwikkeling stelt ons in staat om coding agents correct te dirigeren",
      technologies: "Technologieen die ons vormden",
      technologiesDescription:
        "Van CSS tot Kubernetes, Symfony tot React — we hebben het allemaal gedaan",
      services: "Soorten diensten",
      servicesDescription:
        "Full hands-on development, project audits en technical screenings services",
    },
    features: {
      title: "Wij zorgen dat techniek waarde oplevert.",
      description:
        "Of het nu gaat om software die werkt, projecten die van de grond komen, of mensen die passen — wij versterken jouw organisatie waar technologie het verschil maakt. We bouwen mee aan digitale oplossingen die werken en blijven werken, altijd samen met jouw team.",
      service1Title: "Full-on software development",
      service1Desc: "Agentic software development samen met jouw organisatie, op projectbasis",
      service2Title: "Project feasibility audits",
      service2Desc: "Uw 'second opinion', al vanaf €1495,- ex btw.",
      service3Title: "Technical screening services",
      service3Desc: "Hulp bij het maken van de juiste hires voor jouw organisatie",
    },
    technologies: {
      title: "Veel gebruikte technieken",
    },
    contact: {
      title: "Een uitdaging liggen?",
      description: "Laat je gegevens achter en wij nemen zo snel mogelijk contact met je op.",
      phone: "Telefoon",
      email: "Email",
      submit: "Verstuur",
      thanksTitle: "Bedankt voor je aanvraag!",
      thanksDescription: "We nemen zo snel mogelijk contact met je op.",
    },
    testimonials: {
      title: "Organisaties die wij reeds hebben versterkt",
    },
    agenticTools: {
      title: "Onze favoriete agentic tools",
    },
    manifesto: {
      title: "Ons Agentic Engineering Manifesto",
      description:
        "Verantwoorde AI gedreven development staat centraal in alles wat wij doen. Wij geloven dat agentic engineering de kracht heeft om organisaties te transformeren, maar alleen wanneer het op een ethische en verantwoorde manier wordt ingezet.",
      bullet1: "Menselijke controle behouden over belangrijke beslissingen",
      bullet2: "Eigenaarschap nemen over het gerealiseerde resultaat van agents",
      bullet3: "Verantwoordelijke AI-implementatie met oog voor ethiek",
      bullet4: "Iteratieve ontwikkeling met continue evaluatie",
    },
    services: {
      title: "Onze diensten",
      subtitle:
        "Praktische ondersteuning voor softwareontwikkeling, audits en technische screening.",
      intro:
        "Wij bieden drie kerndiensten aan die uw organisatie versterken op het gebied van technologie en softwareontwikkeling.",
      service1Title: "Full-on software development",
      service1Desc:
        "Wij bouwen samen met uw organisatie complete softwareoplossingen op projectbasis. Onze aanpak combineert hands-on ontwikkeling met agentic engineering om efficiënt en effectief resultaten te leveren. Of het nu gaat om het ontwikkelen van nieuwe applicaties, het moderniseren van bestaande systemen of het bouwen van integraties - wij leveren kwaliteit.",
      service1Keypoints: [
        "Agentic software development met moderne tools",
        "Full-stack ontwikkeling van frontend tot backend",
        "Flexibele projectbasis met transparante planning",
      ],
      service2Title: "Project feasibility audits",
      service2Desc:
        "Heeft u een (lopend) softwareproject maar twijfelt u of het haalbaar is? Wij geven u een onafhankelijk oordeel. Onze audits evalueren de technische haalbaarheid, de verwachte kosten en de risico's van uw project. U krijgt een gedetailleerd rapport met concrete aanbevelingen.",
      service2Keypoints: [
        "Onafhankelijke technische beoordeling",
        "Kostenefficiënt vanaf €1495,- ex btw",
        "Direct bruikbaar actieplan met aanbevelingen",
      ],
      service3Title: "Technical screening services",
      service3Desc:
        "Het vinden van de juiste tech-talenten is cruciaal voor het succes van uw organisatie. Wij helpen u bij het screenen van kandidaten op technische vaardigheden en culturele fit. Of het nu gaat om het beoordelen van code, het voeren van technische gesprekken of het adviseren in hiring-beslissingen.",
      service3Keypoints: [
        "Technische assessments op maat",
        "Beoordeling van codekwaliteit en architectuur",
        "Advies bij hiring-beslissingen",
      ],
    },
    method: {
      title: "Onze werkwijze",
      subtitle:
        "Een heldere, gefaseerde aanpak waarmee softwareprojecten beheersbaar en voorspelbaar blijven.",
      intro:
        "Wij geloven in een gestructureerde, transparante aanpak die resulteert in werkende oplossingen.",
      intakeTitle: "1. Intake",
      intakeDesc:
        "Tijdens het intake gesprek inventariseren we jouw uitdagingen, doelen en wensen. We luisteren aandachtig om een compleet beeld te krijgen van wat je nodig hebt.",
      offerteTitle: "2. Offerte & Planning",
      offerteDesc:
        "Op basis van de intake stellen wij een gedetailleerde offerte op met een heldere projectplanning. Hierin staat precies wat je kunt verwachten qua tijdlijn, kosten en resultaten.",
      phasesTitle: "3. Gefaseerde Uitvoering",
      phasesDesc:
        "Wij werken in korte fasen met tussentijdse evaluaties. Dit zorgt voor flexibiliteit en de mogelijkheid om bij te sturen waar nodig.",
      dbaTitle: "Wet DBA & Offerte",
      dbaDesc:
        "Door te werken met een vaste offerte en gefaseerde projectaanpak voldoen wij aan de Wet DBA. Dit biedt jou als opdrachtgever zekerheid over de afgesproken werkzaamheden en kosten, en ons als opdrachtnemer duidelijkheid over de scope.",
      dbaExplanation:
        "De Wet DBA (Deregulering Beoordeling Arbeidsrelaties) stelt dat een opdrachtnemer zelfstandig moet kunnen opereren. Door gefaseerd te werken met duidelijke tussenresultaten tonen wij aan dat wij onze eigen werkwijze bepalen en verantwoordelijkheid dragen voor het eindresultaat.",
      dbaFineprint:
        "NB: dit sluit een nauwe samenwerking met jullie teams zeker niet uit, integendeel! We geloven juist in een sterke samenwerking, waarin we gezamenlijk optrekken met behoud van onze verantwoordelijkheid voor het zelfstandige aspect van de opdracht en de bijbehorende werkwijze. Bijv. via een eigen JIRA-board.",
    },
    contactPage: {
      title: "Contact",
      subtitle: "Een complex software vraagstuk liggen?",
      intro:
        "Neem contact met ons op om te bespreken hoe wij jouw organisatie kunnen versterken met onze expertise in softwareontwikkeling en agentic engineering.",
      howWeHelp: "Hoe wij jou kunnen helpen",
      howWeHelpDesc:
        "Met meer dan 23 jaar ervaring in softwareontwikkeling begrijpen wij de uitdagingen waar organisaties voor staan. Wij helpen je graag bij het realiseren van je softwareprojecten.",
      summaryTitle: "Onze diensten",
      summary1: "Full-on software development op projectbasis",
      summary2: "Project feasibility audits voor haalbaarheidsanalyses",
      summary3: "Technical screening services voor de juiste hires",
    },
    services_en: {
      title: "Our services",
      intro:
        "We offer three core services that strengthen your organization across technology and software development.",
      service1Title: "Full-on software development",
      service1Desc:
        "We build complete software solutions together with your organization on a project basis. Our approach combines hands-on development with agentic engineering to deliver results efficiently and effectively. Whether you need a new application, a modernization of an existing system or a solid integration, we deliver quality.",
      service1Keypoints: [
        "Agentic software development with modern tooling",
        "Full-stack development from frontend to backend",
        "Flexible/project based with transparent planning",
      ],
      service2Title: "Project feasibility audits",
      service2Desc:
        "Do you have a software project, whether it's already underway or still in the idea stage, and are you unsure whether it's feasible? We give you an independent assessment. Our audits evaluate the technical feasibility, expected costs and risks of your project. You receive a detailed report with concrete recommendations.",
      service2Keypoints: [
        "Independent technical assessment",
        "Cost-effective from €1495 ex VAT",
        "Practical action plan with clear recommendations",
      ],
      service3Title: "Technical screening services",
      service3Desc:
        "Finding the right tech talent is crucial to your organization's success. We help you screen candidates for technical ability and team fit. Whether it's reviewing code, joining technical interviews or advising on hiring decisions, we help you make the right call.",
      service3Keypoints: [
        "Tailored technical assessments",
        "Review of code quality and architecture",
        "Advice on hiring decisions",
      ],
    },
  },
  en: {
    nav: {
      emtay: "Emtay",
      services: "Services",
      contact: "Contact",
      ourmethod: "How we work",
      ourservices: "Our services",
    },
    hero: {
      title: "Emtay: agentic engineering",
      subtitle: "We help organizations turn software challenges into results.",
    },
    counters: {
      yearsExperience: "23 years of experience",
      yearsDescription:
        "Decades of software development help us steer coding agents in the right direction",
      technologies: "Technologies that shaped us",
      technologiesDescription: "From CSS to Kubernetes, from Symfony to React, we've done it all",
      services: "Service types",
      servicesDescription:
        "Full hands-on development, project audits and technical screening services",
    },
    features: {
      title: "We make technology deliver value.",
      description:
        "Whether you need software that works, projects that actually get off the ground, or people who are the right fit, we strengthen your organization where technology makes the difference. We help build digital solutions that work and keep working, always together with your team.",
      service1Title: "Full-on software development",
      service1Desc:
        "Agentic software development together with your organization, on a project basis",
      service2Title: "Project feasibility audits",
      service2Desc: "Your second opinion, starting at €1495 ex VAT.",
      service3Title: "Technical screening services",
      service3Desc: "Help finding the right hires for your organization",
    },
    technologies: { title: "Frequently used technologies" },
    contact: {
      title: "Got a challenge?",
      description: "Leave your details and we'll get in touch as soon as possible.",
      phone: "Phone",
      email: "Email",
      submit: "Send",
      thanksTitle: "Thank you for your request!",
      thanksDescription: "We'll get in touch as soon as possible.",
    },
    testimonials: { title: "Organizations we've already supported" },
    agenticTools: { title: "Our favorite agentic tools" },
    manifesto: {
      title: "Our Agentic Engineering Manifesto",
      description:
        "Responsible AI powered development is central to everything we do. We believe agentic engineering has the power to transform organizations, but only when it is applied in an ethical and responsible way.",
      bullet1: "Keep humans in control of important decisions",
      bullet2: "Take ownership of the results agents deliver",
      bullet3: "Responsible AI implementation with ethical awareness",
      bullet4: "Iterative development with continuous evaluation",
    },
    method: {
      title: "Our method",
      subtitle: "A clear, phased approach that keeps software projects manageable and predictable.",
      intro: "We believe in a structured, transparent approach that leads to working solutions.",
      intakeTitle: "1. Intake",
      intakeDesc:
        "During the intake, we map out your challenges, goals and wishes. We listen carefully so we get a complete picture of what you need.",
      offerteTitle: "2. Quote & Planning",
      offerteDesc:
        "Based on the intake, we prepare a detailed quote with a clear project plan. It spells out exactly what you can expect in terms of timeline, costs and results.",
      phasesTitle: "3. Phased Execution",
      phasesDesc:
        "We work in short phases with regular check-ins. That keeps things flexible and gives us room to adjust where needed.",
      dbaTitle: "Dutch DBA Act & Quote",
      dbaDesc:
        "By working with a fixed quote and a phased project approach, we comply with the Dutch DBA Act. That gives you, as the client, clarity on the agreed work and costs, and gives us clarity on the scope.",
      dbaExplanation:
        "The Dutch DBA Act (Deregulering Beoordeling Arbeidsrelaties) requires a contractor to be able to operate independently. By working in phases with clear interim results, we show that we determine our own way of working and take responsibility for the end result.",
      dbaFineprint:
        "This definitely does not rule out close collaboration with your team, quite the opposite. We believe in working closely together while still taking responsibility for the independent nature of the assignment and the way we work. For example, through our own Jira board.",
    },
    contactPage: {
      title: "Contact",
      subtitle: "Got a complex software challenge on your hands?",
      intro:
        "Get in touch to discuss how we can strengthen your organization with our expertise in software development and agentic engineering.",
      howWeHelp: "How we can help",
      howWeHelpDesc:
        "With more than 23 years of experience in software development, we understand the challenges organizations face. We'd be happy to help move your software projects forward.",
      summaryTitle: "Our services",
      summary1: "Full-on software development on a project basis",
      summary2: "Project feasibility audits to assess viability",
      summary3: "Technical screening services for the right hires",
    },
    services: {
      title: "Our services",
      subtitle: "Practical support for software development, audits and technical screening.",
      intro:
        "We offer three core services that strengthen your organization across technology and software development.",
      service1Title: "Full-on software development",
      service1Desc:
        "We build complete software solutions together with your organization on a project basis. Our approach combines hands-on development with agentic engineering to deliver results efficiently and effectively. Whether you need a new application, a modernization of an existing system or a solid integration, we deliver quality.",
      service1Keypoints: [
        "Agentic software development with modern tooling",
        "Full-stack development from frontend to backend",
        "Flexible project basis with transparent planning",
      ],
      service2Title: "Project feasibility audits",
      service2Desc:
        "Do you have a software project, whether it's already underway or still in the idea stage, and are you unsure whether it's feasible? We give you an independent assessment. Our audits evaluate the technical feasibility, expected costs and risks of your project. You receive a detailed report with concrete recommendations.",
      service2Keypoints: [
        "Independent technical assessment",
        "Cost-effective from €1495 ex VAT",
        "Practical action plan with clear recommendations",
      ],
      service3Title: "Technical screening services",
      service3Desc:
        "Finding the right tech talent is crucial to your organization's success. We help you screen candidates for technical ability and team fit. Whether it's reviewing code, joining technical interviews or advising on hiring decisions, we help you make the right call.",
      service3Keypoints: [
        "Tailored technical assessments",
        "Review of code quality and architecture",
        "Advice on hiring decisions",
      ],
    },
  },
};

export const supportedLanguages = [
  { code: "nl", name: "Nederlands", nativeName: "Nederlands" },
  { code: "en", name: "English", nativeName: "English" },
];

export const defaultLanguage = "nl";
